import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import styles from './MarketingShared.module.css';

/** Ação compacta da linha: ícone com tooltip (tone "danger" para excluir). */
function RowAction({ title, onClick, tone = 'neutral', children }) {
  return (
    <Tooltip title={title} arrow>
      <button
        type="button"
        className={`${styles.rowAction} ${tone === 'danger' ? styles.rowActionDanger : ''}`}
        onClick={onClick}
        aria-label={title}
      >
        {children}
      </button>
    </Tooltip>
  );
}

export default RowAction;
